import {t} from 'i18next';
import {Card, Dialog} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import EventLogService from '../services/EventLogService';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import Constants from '../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class EventLogListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new EventLogService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            eventTypeOptions: [],
        };
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            eventType: criteria.eventType,
            ipAddress: criteria.ipAddress,
            userName: criteria.userName,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            eventType: undefined,
            ipAddress: undefined,
            userName: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'eventDate',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('EventType')
            .then((eventTypeOptions) => {
                this.setState({
                    eventTypeOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getEventLogListError'));
            });
    }

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'eventLog.listTitle';
    }
    getCriteriaName() {
        return 'event-log-list-sc';
    }

    getContainerListName() {
        return 'event-log-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaDropdownComponent
                        id='eventTypeSc'
                        name='eventType'
                        showClear
                        label={t('eventLog.eventType')}
                        value={this.state.criteria.eventType}
                        options={this.state.eventTypeOptions}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        filter
                    />
                    <CriteriaTextComponent
                        id='userName-sc'
                        name='userName'
                        label={t('eventLog.userName')}
                        value={this.state.criteria.userEmail}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaTextComponent
                        id='ipAddress-sc'
                        name='ipAddress'
                        label={t('eventLog.ipAddress')}
                        value={this.state.criteria.ipAddress}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {
                field: 'eventDate',
                header: t('eventLog.data'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'eventDate', Constants.DATE_TIME_FORMAT),
            },
            {field: 'userName', header: t('eventLog.userName'), sortable: true},
            {field: 'ipAddress', header: t('eventLog.ipAddress'), sortable: true},
            {
                field: 'eventType',
                header: t('eventLog.eventType'),
                body: (e) => {
                    return e.eventEnumLabel;
                },
                sortable: true,
            },
            {
                key: 'actions',
                header: t('global.details'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }
    prepareHeaderItems() {
        return [];
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        const eventDetails = this.state.eventDetails;
        return (
            <Dialog
                header={t('eventLogListContainer.dialogHeader')}
                visible={this.state.renderDialog}
                style={{width: '30vw'}}
                closable={true}
                onHide={() => {
                    this.setState({
                        renderDialog: false,
                    });
                }}
            >
                <Card
                    footer={() => {
                        return (
                            <React.Fragment>
                                <div className='font-weight-bold'>{eventDetails.param}</div>
                                <hr className='line-footer' />
                            </React.Fragment>
                        );
                    }}
                ></Card>
            </Dialog>
        );
    }

    actionTemplate(rowData) {
        return (
            <ActionLink
                handleClick={() => {
                    this.service
                        .get(rowData.id)
                        .then((el) => {
                            this.setState({
                                renderDialog: true,
                                eventDetails: el,
                            });
                        })
                        .catch(() => {
                            this.showErrorMessage(t('eventLog.err.getEventLogDetails'));
                        });
                }}
                variant='blue'
                className='p-link hover-underline icon-svg right'
                key={'view-button'}
                iconName='mdi-eye'
                iconSide='left'
                iconSize='xs'
                iconColor='blue'
            />
        );
    }
    breadCrumbItems() {
        return [{name: t('eventLog.name'), url: '/event-log-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

EventLogListContainer.defaultProps = {
    detailUrl: '/event-log/details',
    lazy: true,
};

EventLogListContainer.propTypes = {
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(EventLogListContainer));
